<div class="full-height layout-row layout-align-start-center"
     (mouseenter)="isShowActions=true"
     (mouseleave)="isShowActions=false">

  <div class="layout-row text-ellipsis" *ngFor="let packageItem of viewPackages;let last = last"
       [ngClass]="{'item-margin': !last}">
    <span class="br-body-2">{{sitePackageItemsMap[packageItem.type]?.name || sitePackageItemsMap[packageItem.size]?.name}}</span>
    <span ng-if="!$last" class="margin-right-5">,</span>
  </div>

  <div *ngIf="extraPackages?.length" [ngbTooltip]="extraPackagesTemplate" openDelay="300" triggers="hover" class="packages-amount-container">
    <span>+{{extraPackages?.length}}</span>
    <ng-template #extraPackagesTemplate>
      <div class="layout-column">
        <span *ngFor="let extraPackage of extraPackages">
          {{sitePackageItemsMap[extraPackage.type]?.name || sitePackageItemsMap[extraPackage.size]?.name}}
        </span>
      </div>
    </ng-template>
  </div>

  <bringoz-button *ngIf="isShowFilterByButton && isShowActions"
                  type="tertiary"
                  (onClick)="filterByTypeEvent($event)">
    <bringoz-icon iconName="filter"></bringoz-icon>
  </bringoz-button>

</div>
